<template>
  <el-table
    :data="businessList"
    style="width: 100"
    border
    stripe
    :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
    :summary-method="getSummaries"
    show-summary
    @selection-change="handleTableSelect"
  >
    <el-table-column type="expand" width="60" v-if="isShowExpand">
      <template #default="props">
        <div m="4">
          <MaterialTable :materialData="props.row.children"></MaterialTable>
        </div>
      </template>
    </el-table-column>
    <slot name="before" />
    <template v-if="isRateVisible">
      <el-table-column prop="orderFee" label="业务税率" min-width="90" >
        <template #default="{ row }">
          <span>{{ row.orderTaxRate }}%</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderFee" label="单价(含税)" min-width="100" align="right">
        <template #default="{ row }">
          <!-- <el-input v-model="row.orderFee" type="number" @input='handleCalcTotal()'></el-input> -->
          <span>{{ $currency(row.orderFee) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="priceWithRate" label="单价(未税)" min-width="100" align="right">
        <template #default="{ row }">
          <span>{{ priceWithoutRate(row.orderFee, row.amount, true, row.orderTaxRate) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalPrice" label="总价(含税)" min-width="100" align="right">
        <template #default="{ row }">
          <span>{{ numberTimes(row.orderFee, row.amount, true) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalPriceWithRate" label="总价(未税)" min-width="100" align="right">
        <template #default="{ row }">
          <span>{{ totalPriceWithoutRate(row.orderFee, row.amount, true, row.orderTaxRate) }}</span>
        </template>
      </el-table-column>
     </template>
     <slot name="after" />
  </el-table>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, watch } from 'vue'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils'
import $number from 'number-precision'
import $currency from 'currency.js'
import MaterialTable from '@/views/purchasManage/materialInfo/MaterialTable.vue'

export default defineComponent({
  name: 'MiniBusinessList',
  components: {
    MaterialTable
  },
  props: {
    businessList: { type: Array, required: true, default: () => [] },
    isRateVisible: { type: Boolean, required: false, default: true },
    isShowExpand: { type: Boolean, required: false, default: false }
  },
  emits: ['table-select'],

  setup(props, context) {
    const dataMap = reactive({
      isRateVisible: props.isRateVisible,
      businessList: props.businessList,
      isShowExpand: props.isShowExpand,
      numberTimes: (price: any, amount: any, isCurrency: boolean) => numberTimes(price, amount, isCurrency),

      priceWithoutRate: (price: any, amount: any, isCurrency: boolean, rate: any) => priceWithoutRate(price, isCurrency, rate),

      totalPriceWithoutRate: (price: any, amount: any, isCurrency: boolean, rate: any) => totalPriceWithoutRate(price, amount, isCurrency, rate),

      getSummaries(param: any) {
        const { columns, data } = param
        const sums: string[] = []
        columns.forEach((column: any, index: number) => {
          if (index === 0) {
            sums[index] = '合计'
            return
          }
          const values = data.map((item: any) => Number(item[column.property]))
          if (['amount', 'totalPrice', 'totalPriceWithRate', 'received', 'businessAmount', 'receivedAmount', 'remainAmount', 'fee', 'paidAmount', 'paid', 'amountFee', 'invoiceAmount'].includes(column.property) && !values.every((value: any) => Number.isNaN(value))) {
            const sumNum = `${values.reduce((prev: any, curr: any) => {
              const value = Number(curr)
              if (!Number.isNaN(value)) {
                return $number.plus(prev, curr)
              }
              return prev
            }, 0)}`
            sums[index] = ['totalPrice', 'totalPriceWithRate', 'received', 'receivedAmount', 'remainAmount', 'fee', 'paidAmount', 'paid', 'amountFee', 'invoiceAmount'].includes(column.property) ? $currency(sumNum).toString() : sumNum.toString()
          } else {
            sums[index] = ''
          }
        })
        return sums
      },
      handleTableSelect(selection: any) {
        context.emit('table-select', selection)
      }
    })
    watch(() => props.businessList, () => {
      dataMap.businessList = props.businessList
        ? props.businessList.map((k: any) => {
          return {
            ...k,
            id: k.businessId || k.id,
            businessAmount: k.amount,
            totalPrice: dataMap.numberTimes(k.orderFee, k.amount, true),
            totalPriceWithRate: dataMap.totalPriceWithoutRate(k.orderFee, k.amount, true, k.orderTaxRate)
          }
        })
        : []
    }, { immediate: true, deep: true })
    return { ...toRefs(dataMap) }
  }
})
</script>
